import React, { useEffect, useState } from "react";
import RadioInput from "../../../../components/common/ui/Inputs/RadioInput";
import { useDispatch, useSelector } from "react-redux";
import {
  DateInput,
  FileInput,
  TextAreaInput,
  TextInput,
} from "../../../../components/common/ui/Inputs";
import DatePicker from "react-datepicker";
import { additionalResourceActions } from "../../../../_store/additionalResoure.slice";
import { useLocation, useParams } from "react-router-dom";
import Table from "../../../../components/common/table/Table";
import Button from "../../../../components/common/ui/Button";
import calenderSchema from "../../../../validation/Admin/CalenderSchema";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import { history } from "../../../../_helpers";
import editIcon from "../../../../assets/svg/edit-icon.svg";
import deleteIcon from "../../../../assets/svg/delete-icon.svg";
import CustomLoader from "../../../../components/common/ui/Loader";
import { Popup } from "../../../../components/common/ui/NotificationModal/Popup";
import ToggleSwitch from "../../../../components/common/ui/Inputs/ToggleSwitch";
import additionalResourceSchema from "../../../../validation/Admin/additionalResourceSchema";

function CommitteeAdditionalResource() {
  const dispatch = useDispatch();
  //   const { eventType, locationType } = useSelector((x) => x?.dropDown);

  const { resourceForm, getAdditionalResourceListResponse, loading } =
    useSelector((x) => x?.additionalResource);

  const [isPending, setIsPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [editRow, setEditRow] = useState({});
  const [photo, setPhoto] = useState("");
  const [apiParams, setApiParams] = useState(
    `?page=${1}&limit=${10}&status=${true}`
  );
  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);

  const location = useLocation();
  const committee = location?.state?.committee;
  const totalCount = getAdditionalResourceListResponse?.data?.totalItems || 0;
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;

  const columns = [
    {
      //   width: "200px",
      name: "Title",
      key: "memberId",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      //   width: "200px",
      name: "URL",
      key: "memberId",
      selector: (row) => row.url,
      sortable: true,
    },
    {
      //   width: "200px",
      name: "Photo",
      key: "memberId",
      selector: (row) => row.url,
      cell: (row) => (
        <div className="">
          <img height="50px" width="50px" src={ImageURL + row?.photo} alt="" />
        </div>
      ),
      sortable: true,
    },
    {
      width: "80px",
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <img
            src={editIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              editResource(row);
            }}
          />
        </div>
      ),
      sortable: false,
    },
  ];
  useEffect(() => {
    if (!committee) return;
    //get event list for grid
    dispatch(
      additionalResourceActions?.getAdditionalResourceList(committee?._id)
    );
  }, [committee]);

  const editResource = (row) => {
    setEditRow(row);
    const eventRow = { ...row };
    setIsEditMode(true);

    dispatch(additionalResourceActions?.updateForm(eventRow));
  };

  const handleDelete = (row) => {
    Popup({
      title: "Message",
      text: `Are you sure you want to delete the event?`,
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      onConfirm: () => {
        // setEventID(row?._id);

        dispatch(additionalResourceActions?.deleteEvent(row?._id))
          .then((result) => {
            if (result?.payload?.status === 1) {
              setIsPending(false);
              showToastNotification(result?.payload?.message, "success");
              dispatch(additionalResourceActions?.getEventList(committee?._id));
            } else {
              showToastNotification(result?.error?.message, "error");
            }
          })
          .catch((err) => {
            showToastNotification("Failed to create member", "error");
          });
      },
    });
  };

  const handleChange = (e, img) => {
    const form = { ...resourceForm };
    const { name, value, type } = e?.target;
    if (type === "file") {
      const file = e.target.files[0];
      setPhoto(file);
      if (file) {
        const imageUrl = URL.createObjectURL(file);
        form[img] = imageUrl;
      }
    } else {
      form[name] = value;
    }
    dispatch(additionalResourceActions?.updateForm(form));
  };

  const handleSubmit = (e) => {
    // debugger;
    e?.preventDefault();
    setErrorMessage({});
    const formData = new FormData();
    const form = { ...resourceForm };
    form["committee"] = committee?._id;
    delete form["photo"];
    Object.keys(form).forEach((key) => {
      if (form[key] !== undefined && form[key] !== null) {
        formData.append(key, form[key]);
      }
    });
    if (photo) {
      formData.append("photo", photo);
    }

    dispatch(additionalResourceActions?.updateForm(form));
    const { error } = additionalResourceSchema(form);
    if (error?.details) {
      setIsPending(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    formData.delete("photoToShow");
    const request = isEditMode
      ? dispatch(
        additionalResourceActions?.updateAdditionalResource({
          id: editRow?._id,
          formData: formData,
        })
      )
      : dispatch(additionalResourceActions?.createAdditionalResource(formData));
    request
      .then((result) => {
        if (result?.payload?.status === 1) {
          setIsPending(false);
          showToastNotification(result?.payload?.message, "success");
          dispatch(
            additionalResourceActions?.getAdditionalResourceList(committee?._id)
          );
          dispatch(additionalResourceActions?.resetForm({}));
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create member", "error");
      });
  };

  const handleReset = () => {
    setErrorMessage({});
    isEditMode
      ? dispatch(additionalResourceActions?.updateForm(editRow))
      : dispatch(additionalResourceActions?.resetForm({}));
  };

  const handleRowPerPage = (page) => {
    const updatedParams = apiParams
      .replace(/&limit=\d+/, `&limit=${page}`)
      .replace(/([?&])page=\d+/, `$1page=${1}`);
    const updateIdIntoParams = `${committee?._id + updatedParams}`;
    setApiParams(updatedParams);
    dispatch(
      additionalResourceActions?.getAdditionalResourceList(updateIdIntoParams)
    );
    setRowCountPerPage(page);
    setPageNo(1);
  };

  const handlePageChange = (page) => {
    const updatedParams = apiParams.replace(/([?&])page=\d+/, `$1page=${page}`);
    const updateIdIntoParams = `${committee?._id + updatedParams}`;
    setApiParams(updatedParams);
    dispatch(
      additionalResourceActions?.getAdditionalResourceList(updateIdIntoParams)
    );
    setPageNo(page);
  };

  if (loading) return <CustomLoader />;

  return (
    <>
      <div className="d-flex justify-content-end">
        <Button
          className="me-2"
          label="Create"
          status="secondary"
          onClick={() => {
            setIsEditMode(false);
            dispatch(additionalResourceActions?.resetForm({}));
          }}
        />
        <Button
          label="Back"
          status="reset"
          onClick={() => {
            history?.navigate("/Admin/CommitteePage");
          }}
        />
      </div>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
          {isEditMode ? "Edit" : "Create"} Resource
        </h1>

        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
          className="p-3 row mb-4"
        >
          <div className="col-md-4">
            <TextInput
              name="title"
              id="title"
              label="Title"
              placeholder="Title"
              handleChange={(e) => {
                handleChange(e);
              }}
              value={resourceForm?.title}
              required
              errorMessage={errorMessage}
            />
          </div>
          <div className="col-md-4">
            <TextInput
              name="url"
              id="url"
              label="URL"
              placeholder="Enter URL"
              handleChange={(e) => {
                handleChange(e);
              }}
              value={resourceForm?.url}
              required
              errorMessage={errorMessage}
            />
          </div>

          <div className="col-md-4 d-flex">
            <FileInput
              name="photo"
              label="Photo"
              imageURL={
                resourceForm?.photoToShow === undefined
                  ? resourceForm?.photo && ImageURL + resourceForm?.photo
                  : resourceForm?.photoToShow
              }
              handleFileChange={(e) => {
                handleChange(e, "photoToShow");
              }}
              required
              errorMessage={errorMessage}
            />
          </div>

          <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
            <Button
              label={isEditMode ? "Update" : "Add"}
              status="primary"
              type="submit"
              disabled={isPending}
            />
            <Button
              label="Reset"
              status="reset"
              type="reset"
              onClick={() => {
                handleReset();
              }}
            />
          </div>
        </form>
      </div>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color p-3 ">
          Additional Resource List
        </h1>
        <Table
          columns={columns}
          data={getAdditionalResourceListResponse?.data?.aditionalResources}
          pagination
          onChangeRowsPerPage={handleRowPerPage}
          onChangePage={handlePageChange}
          totalRowCount={totalCount || 0}
          currentPage={pageNo}
          paginationPerPage={rowCountPerPage}
        />
      </div>
    </>
  );
}

export default CommitteeAdditionalResource;
